import React from 'react';
import { OpenCreditSale } from 'components/commons/openCreditSale/openCreditSale';
import { HTMLSafeInjector } from 'commonsComponents/htmlSafeInjector';
import { FormattedText, formatText } from 'core/i18n';
import { PATH_CONTACT } from 'constants/uTagConstants/paths';

const getCardLimit = scorings => {
    return scorings ? scorings.getIn(['ml2', 'cardLimit']) : 0;
};

const getFormattedText = cms => {
    const defaultText = formatText('CMS-additionalTCText');
    const defaultTooltip = <FormattedText value="CMS-additionalTCTooltip" />;

    if (cms.getIn(['cmsAdditional', 'text']) && cms.getIn(['cmsAdditional', 'tooltip'])) {
        const formattedText = cms.getIn(['cmsAdditional', 'text']).replace(/p>/g, 'span>');
        const text = <HTMLSafeInjector message={formattedText} inline={true} />;
        const tooltip = <HTMLSafeInjector message={cms.getIn(['cmsAdditional', 'tooltip'])} />;

        return { text, tooltip };
    }

    return { text: defaultText, tooltip: defaultTooltip };
};

export const getOpenCredit = ({ cms, scorings }) => {
    const limit = getCardLimit(scorings);
    const { text, tooltip } = getFormattedText(cms);

    return <OpenCreditSale limit={limit} CMSText={text} CMSTooltip={tooltip} tagPath={PATH_CONTACT} />;
};
